export const scoolTheme = {
    primary: '#1976D2',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
};
export var TabsColorEnum;
(function (TabsColorEnum) {
    TabsColorEnum["BALCK"] = "#000000";
    TabsColorEnum["BLUE"] = "#0402C4";
    TabsColorEnum["DARK_GREEN"] = "#008834";
    TabsColorEnum["GREY"] = "#888888";
    TabsColorEnum["LIGHT_BLUE"] = "#028AC4";
    TabsColorEnum["LIGHT_GREEN"] = "#5AC402";
    TabsColorEnum["ORANGE"] = "#C46002";
    TabsColorEnum["PINK"] = "#C4026C";
    TabsColorEnum["PURPLE"] = "#8902C4";
    TabsColorEnum["RED"] = "#C40202";
    TabsColorEnum["YELLOW"] = "#EBC500";
    TabsColorEnum["LIGHT_ORANGE"] = "#F2A900";
})(TabsColorEnum || (TabsColorEnum = {}));
